














































































































































































import {
  Component,
  Vue,
  Watch,
  namespace,
  mixins,
} from 'nuxt-property-decorator'
import LazyHydrate from 'vue-lazy-hydration'
import VueScrollTo from 'vue-scrollto'
import { COLLECTIONS_API } from '~/assets/config/api-path'
import { IStyle } from '~/assets/interfaces/classes'
import { NuxtAppOptions } from '~/node_modules/@nuxt/types'
import { IBreadcrumbsItem } from '~/assets/interfaces/navigation'
import { IMeta } from '~/assets/interfaces/meta'
import { IBanner } from '~/assets/interfaces/banners'
import { IProduct } from '~/assets/interfaces/products'
import { declension } from '~/assets/functions/declension'
import MixinGeneral from '~/assets/mixins/general'
import { filterUrl } from '~/assets/filters/url'
import ComponentProductAdditionalWrapper from '~/components/products/product-additional-wrapper.vue'
import ComponentNavigationBreadcrumbs from '~/components/navigation/breadcrumbs.vue'
import ComponentTypographyH1 from '~/components/typography/h1.vue'
import ComponentPageContent from '~/components/pages/content.vue'
import ComponentSeoFilters from '~/components/navigation/seo-filters.vue'
import ComponentCatalogSorting from '~/components/catalog/sorting.vue'
import ComponentProductItem1 from '~/components/products/product-item-1.vue'
import ComponentHeaderWithLink from '~/components/header/header-with-link.vue'
import ComponentIntersect from '~/components/intersect/intersect.vue'
import ComponentProductItem3 from '~/components/products/product-item-3.vue'
import ComponentMobileProductItem3 from '~/components/mobile/products/m-product-item-3.vue'
import ComponentNavigationPagination from '~/components/navigation/pagination.vue'
import ComponentBannerStandard from '~/components/banners/banner-standard.vue'
import ComponentLoadingDots from '~/components/loading/dots.vue'
import ComponentCategoryPath from '~/components/navigation/category-path.vue'
import ComponentMobileCategoryPath from '~/components/mobile/navigation/m-category-path.vue'
import ComponentCatalogFilter from '~/components/catalog/filter/catalog-filter.vue'
import ComponentMobileCatalogFilter from '~/components/mobile/catalog/filter/m-catalog-filter.vue'
import ComponentCatalogFilterReset from '~/components/catalog/filter/catalog-filter-reset.vue'

const pageStore = namespace('page')
const siteStore = namespace('site')

Vue.use(VueScrollTo)

interface IProductsRaw {
  items: IProduct[]
  type: string
}

@Component({
  // watchQuery: true,
  layout: (ctx) => (ctx.$device.isMobileOrTablet ? 'mobile' : 'default'),
  components: {
    LazyHydrate,
    ComponentAlert: () => import('~/components/alerts/alert.vue'),
    ComponentNavigationBreadcrumbs,
    ComponentTypographyH1,
    ComponentPageContent,
    ComponentSeoFilters,
    ComponentCatalogSorting,
    ComponentProductItem1,
    ComponentHeaderWithLink,
    ComponentIntersect,
    ComponentProductItem3,
    ComponentMobileProductItem3,
    ComponentNavigationPagination,
    ComponentBannerStandard,
    ComponentLoadingDots,
    ComponentCategoryPath,
    ComponentMobileCategoryPath,
    ComponentCatalogFilter,
    ComponentMobileCatalogFilter,
    ComponentCatalogFilterReset,
    ComponentProductAdditionalWrapper,
  },
  filters: {
    filterAmountProducts(num: number, amount: [string, string, string]) {
      return num.toString() + ' ' + declension(num, amount)
    },
  },
})
export default class pageCatalogSection extends mixins(MixinGeneral) {
  private async asyncData({
    $axios,
    route,
    error,
  }: {
    $axios: NuxtAppOptions
    route: NuxtAppOptions
    error: any
  }) {
    try {
      const response = await $axios.$get(
        filterUrl(COLLECTIONS_API + '/' + route.params._slug),
        {
          params: route.query,
        }
      )

      return response
    } catch (err) {
      error({ statusCode: 404, message: 'Post not found' })
    }
  }

  @siteStore.Getter('getFixedHeaderHeight')
  readonly getFixedHeaderHeight!: number

  private async getContent() {
    const response = await this.$axios.$get(
      filterUrl(COLLECTIONS_API + '/' + this.$route.params._slug),
      {
        params: this.$route.query,
      }
    )

    this.meta = response.meta
    this.breadcrumbs = response.breadcrumbs
    this.pages = response.pages
    this.amount = response.amount
    this.seoFilters = response.seoFilters
    this.categoryPath = response.categoryPath
    this.filter = response.filter
    this.banners = response.banners
    this.sorting = response.sorting
    this.products = response.products
    this.productsAdditionalIds = response.productsAdditionalIds
    this.seo = response.seo
  }

  private pages = 0
  private amount = 0
  private seoFilters = []
  private categoryPath = null
  private filter = null
  private sorting = []
  private productsAdditionalIds: number[] = []
  private seo = null

  private styleGrid!: IStyle
  private isLoading = false

  @pageStore.Mutation('setBreadcrumbs') private setBreadcrumbs!: (
    breadcrumbs: IBreadcrumbsItem[]
  ) => void

  @pageStore.Mutation('setMeta') private setMeta!: (meta: IMeta) => void

  private meta: IMeta | null = null
  private breadcrumbs: IBreadcrumbsItem[] = []

  @Watch('meta', {
    immediate: true,
  })
  private metaHandler(val: IMeta) {
    if (val) {
      this.setMeta(val)
    }
  }

  @Watch('breadcrumbs', {
    immediate: true,
  })
  private breadcrumbsHandler(val: IBreadcrumbsItem[]) {
    if (val) {
      this.setBreadcrumbs(val)
    }
  }

  private banners: IBanner[] = []

  private get bannersRenderSidebar() {
    return this.banners.filter((banner) => banner.position === 'sidebar')
  }

  private get bannersRenderMainStart() {
    return this.banners.filter((banner) => banner.position === 'mainStart')
  }

  @Watch('$route')
  private async routeHandler() {
    this.isLoading = true
    await this.getContent()
    this.isLoading = false
    let offset = -1 * (24 + this.getFixedHeaderHeight)
    if (this.$device.isMobileOrTablet) {
      offset = -48
    }
    const el = (this.$refs.page as Vue).$el as HTMLElement
    if (el) {
      VueScrollTo.scrollTo(el, { offset })
    }
  }

  private styleSpacer!: IStyle

  private get classMbGutter() {
    return {
      [this.styleSpacer.mbGutter2]: !this.$device.isMobileOrTablet,
      [this.styleSpacer.mbGutter]: this.$device.isMobileOrTablet,
    }
  }

  private products: IProductsRaw | null = null

  private get componentNameProducts() {
    if (this.products) {
      if (this.products.type === 'table') {
        return 'component-product-item-1'
      } else {
        return this.$device.isMobileOrTablet
          ? 'component-mobile-product-item-3'
          : 'component-product-item-3'
      }
    }
  }

  private get classProducts() {
    return {
      [this.$style.products]: true,
      [this.$style.table]: this.products
        ? this.products.type === 'table'
        : false,
    }
  }
}
